function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClickup = function SvgClickup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 54.8 65.8"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clickup_svg__a",
    x1: 0,
    x2: 54.845,
    y1: 15.049,
    y2: 15.049,
    gradientTransform: "matrix(1 0 0 -1 0 69.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8930fd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#49ccf9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 50.6 10.1-7.8c5.4 7 11.1 10.3 17.4 10.3s11.9-3.2 17-10.2l10.3 7.6c-7.4 10-16.6 15.3-27.3 15.3-10.6 0-19.9-5.3-27.5-15.2",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#clickup_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clickup_svg__b",
    x1: 1.195,
    x2: 53.745,
    y1: 53.166,
    y2: 53.166,
    gradientTransform: "matrix(1 0 0 -1 0 69.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff02f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 16.9-18 15.5-8.3-9.7L27.6 0l26.2 22.7-8.4 9.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#clickup_svg__b)"
    }
  }));
};
export default SvgClickup;